import { createI18n } from "vue-i18n";

const messages = {
  en: {
    map: "Map",
    company: "Company",
    logs: "Data logs",
    employees: "Employees",
    list: "List",
    lists: "Lists",
    statistic: "Statistic",
    statistics: "Statistics",
    charts: "Charts",
    mixed: "Mixed",
    tables: "Tables",
    overview: "Overview",
    examples: "Examples",
    feeds: "Feeds",
    dashboard: "Dashboard",
    layoutBuilder: "Layout builder",
    system: "System",
    systems: "Systems management",
    companies: "Company management",
    menus: "Menu management",
    roles: "Roles management",
    catalogs: "Catalog",
    banks: "Banks list",
    language: "Language",
    download: "Download",
    craft: "info",
    pages: "Pages",
    profile: "Profile",
    profileOverview: "Overview",
    projects: "Projects",
    campaigns: "Campaigns",
    documents: "Documents",
    connections: "Connections",
    wizards: "Wizards",
    horizontal: "Horizontal",
    vertical: "Vertical",
    account: "Account",
    accounts: "Accounts",
    accountOverview: "Overview",
    settings: "Settings",
    authentication: "Authentication",
    basicFlow: "Basic Flow",
    signIn: "Sign-in",
    signUp: "Sign-up",
    signOut: "Sign-out",
    passwordReset: "Password Reset",
    error404: "Error 404",
    error500: "Error 500",
    apps: "Apps",
    chat: "Chat",
    privateChat: "Private Chat",
    groupChat: "Group Chat",
    drawerChat: "Drawer Chat",
    widgets: "Widgets",
    widgetsLists: "Lists",
    widgetsStatistics: "Statistics",
    widgetsCharts: "Charts",
    widgetsMixed: "Mixed",
    widgetsTables: "Tables",
    widgetsFeeds: "Feeds",
    changelog: "Changelog",
    docsAndComponents: "Docs & Components",
    megaMenu: "Mega Menu",
    exampleLink: "Example link",
    modals: "Modals",
    general: "General",
    inviteFriends: "Invite Friends",
    viewUsers: "View Users",
    upgradePlan: "Upgrade Plan",
    shareAndEarn: "Share & Earn",
    forms: "Forms",
    newTarget: "New Target",
    newCard: "New Card",
    newAddress: "New Address",
    createAPIKey: "Create API Key",
    twoFactorAuth: "Two Factor Auth",
    createApp: "Create App",
    createAccount: "Create Account",
    documentation: "Documentation",
    components: "Components",
    resources: "Resources",
    activity: "Activity",
    customers: "Customers",
    gettingStarted: "Getting Started",
    customersListing: "Customers Listing",
    customerDetails: "Customers Details",
  },
  vn: {
    common: {
      home: "Trang chủ",
      login: "Đăng nhập",
      logout: "Thoát",
      doc: "Tài liệu",
      blog: "blog",
      projectRepo: "Dự án",
      myMsg: "Tin nhắn",
      config: "Cấu hình",
      backup: "Backup",
      restore: "Restore",
      backupRestore: "Backup and Restore",
      versionName: "Phiên bản",
      exit: "Thoát",
      topMenu: "Top menu",
      location: "Địa phương",
      pleaseChoose: "Vui lòng chọn",
      deletedSuccessfully: "Xóa thành công",
      stopSuccessfully: "Khởi động lại thành công",
      rebootSuccessfully: " thành công",
      confirmSuccessfully: "Phê duyệt thành công",
      changeModeConfirm: "Bạn có chắc chắn muốn đổi chế độ không？",
      changeModeSuccessfully: "Đổi chế độ thành công",
      changeVolumeConfirm: "Bạn có chắc chắn muốn điều chỉnh âm lượng không？",
      changeVolumeSuccessfully: "Điều chỉnh âm lượng thành công",
      cancelSuccessfully: "Hủy thành công",
      cancelConfirm: "Bạn có chắc chắn muốn hủy không？",
      deleteConfirm: "Bạn có chắc chắn muốn xóa không？",
      stopConfirm: "Bạn có chắc chắn muốn tạm dừng không？",
      rebootConfirm: "Bạn có chắc chắn muốn khởi động lại không？",
      checkConfirm: "Bạn có chắc chắn muốn phê duyệt không？",
      submitConfirm: "Bạn có chắc chắn muốn lưu thay đổi không？",
      submitVerify: "Bạn có chắc chắn muốn xác minh hay không?",
      submitCancelVerify: "Bạn có chắc chắn hủy xác minh hay không?",
      submitConfirmDB:
        "Đóng tab có thể ảnh hưởng đến Phát thanh đồng bộ, tiếp tục？",
      logoutConfirm: "Bạn có chắc chắn muốn thoát không？",
      operationSuccessfully: "Thành công",
      operationFailed: "Thất bại",
      notEmpty: "  không thể trống",
      submitAuthFormError: "Không thể thay đổi vai trò của Super administrator",
      dashboard: "Bảng điều khiển",
      enabled: "kích hoạt",
      state: "Trạng thái",
      active: "Kích hoat",
      inactive: "Không kích hoạt",
      createBy: "Người tạo",
      createTime: "Thời gian tạo",
      userInfo: "Thông tin tài khoản",
      changePassword: "Thay đổi mật khẩu",
      locality: "Địa phương",
      createMp3: "Thêm file Mp3",
      soundRecording: "Ghi âm",
      approved: "Đã duyệt",
      pending: "Chờ duyệt",
      cancelled: "Đã hủy",
      clickToUpload: "Chọn file tải lên",
      notification: "Thông báo",
      schedulePlay: "Lịch phát",
      activeChart: "Biểu đồ trạng thái thiết bị",
      detail: "Chi tiết",
    },
    action: {
      operation: "Hoạt động",
      add: "Thêm",
      edit: "Sửa",
      view: "Xem",
      reboot: "Khởi động lại",
      stop: "Tạm dừng",
      confirm: "Xác nhận",
      delete: "Xóa",
      batchDelete: "Xóa hàng loạt",
      search: "Tìm kiếm",
      loading: "Đang tải",
      submit: "Ghi nhận",
      verify: "Xác minh",
      cancel_verify: "Từ chối",
      cancel: "Hủy",
      reset: "Thiết lập lại",
      refresh: "Làm mới",
      columnDisplay: "Hiển thị cột",
      selectAll: "Chọn tất cả",
      import: "Import",
      export: "Export",
      modechange: "Đổi chế độ phát",
      volume: "Điều chỉnh âm lượng",
      login: "Đăng nhập",
      ok: "OK",
      excel: "Xuất Excel",
      upload: "Tải lên",
      check: "Kiểm tra",
      checkAndUpload: "Kiểm tra + Tải lên",
    },

    msg: {
      accountNotExist: "Tài khoản không tồn tại",
      accountPermission: "Người dùng không có quyền truy cập",
      passwordIncorrect: "Mật khẩu không chính xác",
      accountLocked:
        "Tài khoản của bạn đã bị khóa. Vui lòng liên hệ quản trị viên.",
      ldapFailed:
        "Không thể xác thực tài khoản. Vui lòng liên hệ quản trị viên.",
    },

    invalid: {
      userNameEmpty: "Vui lòng nhập một tài khoản",
      passwordEmpty: "Vui lòng nhập mật khẩu",
      fullNameEmpty: "Vui lòng nhập họ tên",
      phoneNumberEmpty: "Vui lòng nhập số điện thoại",
      identityCardEmpty: "Vui lòng nhập thẻ căn cước (CMND)",
      roleNameEmpty: "Vui lòng nhập tên quyền",
      groupNameEmpty: "Vui lòng nhập tên nhóm quyền",
      menuNameEmpty: "Vui lòng nhập tên chức năng",
      labelNameEmpty: "Vui lòng nhập tên",
      piorityLevelEmpty: "Vui lòng nhập cấp độ ưu tiên",
      localityEmpty: "Vui lòng nhập địa phương",
      registryIdEmpty: "Vui lòng nhập mã đăng ký",
      localityDataEmpty: "Vui lòng chọn địa phương",
      serialEmpty: "Vui lòng nhập serial",
      selectedRole: "Vui lòng chọn vai trò",
      selectedLocality: "Vui lòng chọn địa phương",
    },

    title: {
      menuRouting:
        "<p> Định dạng liên kết: </p>\n<p> 1. Chức năng liên kết dùng để tạo đường dẫn trang, chẳng hạn như quản lý người dùng, đường dẫn trang trong chế độ xem là /Sys/User, tại đây /sys/user. </p>\n<p> 2. Lồng các trang web bên ngoài, chẳng hạn như mở các trang web google thông qua menu, điền vào http://www.google.com tại đây, không thể bỏ qua http: //. </p>\n<p> Ví dụ: Quản lý người dùng: /sys/user, Google: http://www.google.com, Trang web: http://127.0.0.1:8000 </p>\n",
      icon: '<p>Các bước sử dụng：</p>\n<p>1. Truy cập trang <a href="http://www.fontawesome.com.cn/faicons/" target="_blank">Font Aweson</a> </p>\n<p>2. Tìm biểu tượng bạn cần và nhấp để xem biểu tượng đó</p>\n<p>3. Sao chép mã biểu tượng</p>\n<p>Ví dụ： fa fa-home fa-lg</p>',
    },

    sys: {
      sysMng: "Quản lý hệ thống",
      userMng: "Quản lý người dùng",
      deptMng: "Quản lý tổ chức",
      roleMng: "Quản lý vai trò",
      menuMng: "Quản lý danh mục",
      logMng: "Quản lý log",
      sysMonitor: "Giám sát hệ thống",
    },

    user: {
      userName: "Tên tài khoản",
      fullName: "Họ tên",
      password: "Mật khẩu",
      iconFile: "Avatar",
      deptName: "Tổ chức",
      email: "Email",
      mobile: "Số điện thoại",
      ez: "Số EZ",
      lyDo: "Lý do",
      cmnd: "Số CMND",
      cmndTruoc: "mặt trước cmnd",
      cmndSau: "mặt sau cmnd",
      userRoles: "Vai trò",
      userGroups: "Nhóm vai trò",
      status: "Trạng thái",
      verifiedFlag: "Xác minh",
      oldPassword: "Mật khẩu hiện tại",
      newPassword: "Mật khẩu mới",
      confirmPassword: "Nhập lại mật khẩu mới",
      lydo: "Lý do",
    },
    "Network Error": "Lỗi kết nối",
    role: {
      name: "Tên",
      remark: "Lưu ý",
      roleMenuTitle: "Phân quyền menu",
      loading: "Đang tải dữ liệu",
      createBy: "Người tạo",
      createTime: "Thời gian tạo",
    },
    menu: {
      name: "Tên",
      icon: "Icon",
      type: "Loại",
      loading: "Đang tải dữ liệu",
      tableOfContents: "Menu gốc",
      menu: "Menu",
      button: "Button",
      external: "Liên kết ngoài",
      parentMenu: "Menu Cha",
      menuUrl: "Menu URL",
      authorization: "Phân quyền",
      orderNum: "Số thứ tự",
      menuRouting: "Liên kết",
    },
    sysConfig: {
      configKey: "Key",
      value: "Value",
    },
    log: {
      name: "Tên",
      method: "Phương thức",
      params: "Tham số",
      ip: "IP",
      time: "Thời gian",
      createBy: "Người tạo",
      createTime: "Thời gian tạo",
    },
    login: {
      usernamePlaceholder: "Username",
      passwordPlaceholder: "Password",
      loginButton: "Sign In",
      isLoginExpired: "Your session has expired, please sign in again.",
      isCredentialsInvalid: "The username and / or password is incorrect.",
      isLogout: "Session ended successfully!",
    },
    dialogs: {
      save: "Save",
      cancel: "Cancel",
    },
    date: {
      today: "Today",
      yesterday: "Yesterday",
    },
    page404: {
      button: "Oops! Click here to return to the home page.",
    },

    filters: {
      provinceName: "Tỉnh/thành",
      districtName: "Quận/huyện",
      teller: "Giao dịch viên",
      saler: "Nhân viên",
      month: "Tháng",
      targets: "Bộ chỉ tiêu",
      target: "Chỉ tiêu",
      isdn: "Số thuê bao",
      activeDate: "Ngày KH",
      memberCode: "Mã nhân viên",
    },

    map: "Bản đồ",
    company: "Công ty",
    logs: "Nhật ký dữ liệu",
    employees: "Quản lý nhân viên",
    list: "Danh sách",
    lists: "Danh sách",
    statistic: "Số liệu",
    statistics: "Số liệu",
    charts: "Biểu đồ",
    mixed: "Tổng hợp",
    tables: "Bảng",
    feeds: "Bảng tin",
    overview: "Tổng quan",
    examples: "Mẫu",
    dashboard: "Dashboard",
    system: "Hệ thống",
    systems: "Quản lý hệ thống",
    companies: "Quản lý công ty",
    menus: "Quản lý chức năng",
    roles: "Quản lý phân quyền",
    catalogs: "Danh mục",
    banks: "Danh sách ngân hàng",
    language: "Ngôn ngữ",
    download: "Tải xuống",
    layoutBuilder: "Thiết lập trang",
    craft: "Thông tin",
    pages: "Trang",
    profile: "Hồ sơ cá nhân",
    profileOverview: "Tổng quan",
    projects: "Dự án",
    campaigns: "Chiến dịch",
    documents: "Tài liệu",
    connections: "Quan hệ",
    wizards: "Wizards",
    horizontal: "Dọc",
    vertical: "Ngang",
    account: "Tài khoản",
    accounts: "Quản lý tài khoản",
    accountOverview: "Tổng quan",
    settings: "Cài đặt",
    authentication: "Xác thực",
    basicFlow: "Basic Flow",
    signIn: "Đăng nhập",
    signUp: "Đăng ký",
    signOut: "Đăng xuất",
    passwordReset: "Đặt lại mật khẩu",
    error404: "Error 404",
    error500: "Error 500",
    apps: "Apps",
    chat: "Chat",
    privateChat: "Chat riêng",
    groupChat: "Chat nhóm",
    drawerChat: "Drawer Chat",
    widgets: "Công cụ",
    widgetsLists: "Công cụ danh sách",
    widgetsStatistics: "Công cụ  số liệu",
    widgetsCharts: "Công cụ biểu đồ",
    widgetsMixed: "Công cụ tổng hợp",
    widgetsTables: "Công cụ bảng",
    widgetsFeeds: "Công cụ bảng tin",
    changelog: "Thay đỏi",
    docsAndComponents: "Tài liệu và công cụ",
    megaMenu: "Mega Menu",
    exampleLink: "Link mẫu",
    modals: "Modals",
    general: "Chung",
    inviteFriends: "Mời bạn",
    viewUsers: "Xem người dùng",
    upgradePlan: "Nâng cấp",
    shareAndEarn: "Chia sẻ",
    forms: "Mẫu",
    newTarget: "Đối tượng mới",
    newCard: "Thẻ mới",
    newAddress: "Địa chỉ mới",
    createAPIKey: "Tạo khóa API mới",
    twoFactorAuth: "Xác thực 2 yêu tố",
    createApp: "Tạo App",
    createAccount: "Tạo tài khoản",
    documentation: "Tài liệu",
    components: "Công cụ",
    resources: "Tài nguyên",
    activity: "Hoạt động",
    customers: "Quản lý khách hàng",
    gettingStarted: "Bắt đầu",
    customersListing: "Danh sách khách hàng",
    customerDetails: "Chi tiết khách hàng",
  },
  es: {
    dashboard: "Tablero",
    layoutBuilder: "Constructor de maquetación",
    craft: "Elaborado",
    pages: "Paginas",
    profile: "Perfil",
    profileOverview: "Descripción general",
    projects: "Proyectos",
    campaigns: "Campañas",
    documents: "Documentos",
    connections: "Conexiones",
    wizards: "Magos",
    horizontal: "Horizontal",
    vertical: "Vertical",
    account: "Cuenta",
    accountOverview: "Descripción general",
    settings: "Ajustes",
    authentication: "Autenticación",
    basicFlow: "Flujo básico",
    signIn: "Registrarse",
    signUp: "Inscribirse",
    passwordReset: "Restablecimiento de contraseña",
    error404: "Error 404",
    error500: "Error 500",
    apps: "Aplicaciones",
    chat: "Chat",
    privateChat: "Chat privado",
    groupChat: "Grupo de chat",
    drawerChat: "Chat del cajón",
    widgets: "Widgets",
    widgetsLists: "Liza",
    widgetsStatistics: "Estadísticas",
    widgetsCharts: "Gráficos",
    widgetsMixed: "Mezclada",
    widgetsTables: "Mesas",
    widgetsFeeds: "Alimenta",
    changelog: "Registro de cambios",
    docsAndComponents: "Documentos & Componentes",
    megaMenu: "Mega menú",
    exampleLink: "Enlace de ejemplo",
    modals: "Modales",
    general: "General",
    inviteFriends: "Invitar A Amigos",
    viewUsers: "Ver Usuarios",
    upgradePlan: "Plan De Actualización",
    shareAndEarn: "Compartir Y Ganar",
    forms: "Formas",
    newTarget: "Nuevo Objetivo",
    newCard: "Nueva Tarjeta",
    newAddress: "Nueva Direccion",
    createAPIKey: "Crea Clave De Api",
    twoFactorAuth: "Dos Factores",
    createApp: "Crear Aplicacion",
    createAccount: "Crear Una Cuenta",
    activity: "Actividad",
    documentation: "Documentación",
    components: "Componentes",
    resources: "Recursos",
    customers: "Clientes",
    gettingStarted: "Empezando",
    customersListing: "Listado De Clientes",
    customerDetails: "Detalles De Los Clientes",
  },
  de: {
    dashboard: "Instrumententafel",
    layoutBuilder: "Layout-Builder",
    craft: "Hergestellt",
    pages: "Seiten",
    profile: "Profil",
    profileOverview: "Überblick",
    projects: "Projekte",
    campaigns: "Kampagnen",
    documents: "Unterlagen",
    connections: "Anschlüsse",
    wizards: "Zauberer",
    horizontal: "Horizontal",
    vertical: "Vertikal",
    account: "Konto",
    accountOverview: "Überblick",
    settings: "Die Einstellungen",
    authentication: "Authentifizierung",
    basicFlow: "Grundfluss",
    signIn: "Einloggen",
    signUp: "Anmelden",
    passwordReset: "Passwort zurücksetzen",
    error404: "Fehler 404",
    error500: "Fehler 500",
    apps: "Apps",
    chat: "Plaudern",
    privateChat: "Private Chat",
    groupChat: "Privater Chat",
    drawerChat: "Gruppenchat Schubladen-Chat",
    widgets: "Widgets",
    widgetsLists: "Listen",
    widgetsStatistics: "Statistiken",
    widgetsCharts: "Diagramme",
    widgetsMixed: "Gemischt",
    widgetsTables: "Tabellen",
    widgetsFeeds: "Einspeisungen",
    changelog: "Änderungsprotokoll",
    docsAndComponents: "Dokumente & Komponenten",
    megaMenu: "Mega-Menü",
    exampleLink: "Beispiellink",
    modals: "Modale",
    general: "Allgemeines",
    inviteFriends: "Freunde Einladen",
    viewUsers: "Benutzer Anzeigen.",
    upgradePlan: "Upgrade-Plan",
    shareAndEarn: "Teilen & Verdienen",
    forms: "Formen",
    newTarget: "Neues Ziel",
    newCard: "Neue Karte",
    newAddress: "Neue Adresse",
    createAPIKey: "Api-Key Erstellen",
    twoFactorAuth: "Zwei Faktor Auth.",
    createApp: "App Erstellen",
    createAccount: "Benutzerkonto Erstellen",
    activity: "Aktivität",
    documentation: "Dokumentation",
    components: "Bauteile",
    resources: "Ressourcen",
    customers: "Kunden",
    gettingStarted: "Einstieg",
    customersListing: "Kundenauflistung",
    customerDetails: "Kundenangaben",
  },
  ja: {
    dashboard: "ダッシュボード",
    layoutBuilder: "レイアウトビルダー",
    craft: "作成された",
    pages: "ページ",
    profile: "プロフィール",
    profileOverview: "概要",
    projects: "プロジェクト",
    campaigns: "キャンペーン",
    documents: "書類",
    connections: "接続",
    wizards: "ウィザード",
    horizontal: "横",
    vertical: "垂直",
    account: "アカウント",
    accountOverview: "概要",
    settings: "設定",
    authentication: "認証",
    basicFlow: "基本的な流れ",
    signIn: "サインイン",
    signUp: "サインアップ",
    passwordReset: "パスワードのリセット",
    error404: "エラー404",
    error500: "エラー 500",
    apps: "アプリ",
    chat: "チャット",
    privateChat: "プライベートチャット",
    groupChat: "グループチャット",
    drawerChat: "ドロワーチャット",
    widgets: "ウィジェット",
    widgetsLists: "リスト",
    widgetsStatistics: "統計",
    widgetsCharts: "チャート",
    widgetsMixed: "混合",
    widgetsTables: "テーブル",
    widgetsFeeds: "フィード",
    changelog: "変更ログ",
    docsAndComponents: "ドキュメントとコンポーネント",
    megaMenu: "メガメニュー",
    exampleLink: "リンク例",
    modals: "モーダルズ",
    general: "一般",
    inviteFriends: "友達を招待",
    viewUsers: "ユーザーを表示します",
    upgradePlan: "アップグレードプラン",
    shareAndEarn: "シェア＆稼働",
    forms: "フォーム",
    newTarget: "新しいターゲット",
    newCard: "新しいカード",
    newAddress: "新しいアドレス",
    createAPIKey: "Apiキーを作成します",
    twoFactorAuth: "2つの要因Auth",
    createApp: "アプリを作成します",
    createAccount: "アカウントを作成する",
    activity: "アクティビティ",
    documentation: "ドキュメンテーション",
    components: "コンポーネント",
    resources: "資力",
    customers: "お客様のお客様",
    gettingStarted: "入門",
    customersListing: "顧客のリスト",
    customerDetails: "お客様の詳細",
  },
  fr: {
    dashboard: "Générateur de mise",
    layoutBuilder: "En page",
    craft: "Fabriqué",
    pages: "Pages",
    profile: "Profil",
    profileOverview: "Aperçu",
    projects: "Projets",
    campaigns: "Campagnes",
    documents: "Documents",
    connections: "Connexions",
    wizards: "Sorciers",
    horizontal: "Horizontal",
    vertical: "Verticale",
    account: "Compte",
    accountOverview: "Aperçu",
    settings: "Paramètres",
    authentication: "Authentification",
    basicFlow: "Flux de base",
    signIn: "SS'identifier",
    signUp: "Inscrivez-vous",
    passwordReset: "Réinitialisation du mot de passe",
    error404: "Erreur 404",
    error500: "Erreur 500",
    apps: "Applications",
    chat: "Discuter",
    privateChat: "Discussion privée",
    groupChat: "Discussion de groupe",
    drawerChat: "Chat de tiroir",
    widgets: "Widgets",
    widgetsLists: "Listes",
    widgetsStatistics: "Statistiques",
    widgetsCharts: "Graphiques",
    widgetsMixed: "Mixte",
    widgetsTables: "Les tables",
    widgetsFeeds: "Flux",
    changelog: "Journal des modifications",
    docsAndComponents: "Documents & composants",
    megaMenu: "Méga Menu",
    exampleLink: "Exemple de lien",
    modals: "Modals",
    general: "Général",
    inviteFriends: "Inviter Des Amis",
    viewUsers: "Voir Les Utilisateurs",
    upgradePlan: "Plan De Mise À Niveau",
    shareAndEarn: "Partager Et Gagner",
    forms: "Formes",
    newTarget: "Nouvelle Cible",
    newCard: "Nouvelle Carte",
    newAddress: "Nouvelle Adresse",
    createAPIKey: "Créer Une Touche Api",
    twoFactorAuth: "Deux Facteurs D'Authentification",
    createApp: "Créer Une Application",
    createAccount: "Créer Un Compte",
    activity: "Activité",
    documentation: "Documentation",
    components: "Composants",
    resources: "Ressources",
    customers: "Les Clients",
    gettingStarted: "Commencer",
    customersListing: "Liste Des Clients",
    customerDetails: "Détails Des Clients",
  },
};
const i18n = createI18n({
  legacy: false,
  locale: "vn",
  globalInjection: true,
  messages,
});

export default i18n;
